import { Link } from "react-router-dom";
import { BRAND } from "@blackthorn/shared";
import SEO from "../components/SEO.jsx";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
      <SEO
        title="Page not found"
        description="This page doesn't exist. Head back to the Blackthorn homepage or the docs."
        path="/404"
      />
      {/* Local glow behind the 404 */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(45% 40% at 50% 45%, rgba(143,29,44,0.22), transparent 70%)" }}
      />
      <div className="relative">
        {/* Glitch-style 404 */}
        <h1 className="text-8xl md:text-9xl font-bold tracking-tighter select-none" data-text="404">
          <span className="relative inline-block text-bt-text">
            404
            <span aria-hidden className="absolute inset-0 text-bt-accent opacity-60 translate-x-[3px] animate-pulse">404</span>
            <span aria-hidden className="absolute inset-0 text-bt-steel opacity-50 -translate-x-[3px]">404</span>
          </span>
        </h1>
        <img src="/blackthorn-icon.svg" alt="" className="mx-auto w-14 h-14 mt-2 opacity-80" />
        <h2 className="mt-6 text-2xl font-semibold tracking-tight">Lost in the thorns.</h2>
        <p className="mt-3 text-bt-muted max-w-md mx-auto">
          This page doesn't exist - it may have been moved, or the link is wrong.
          Even the thorns couldn't verify it.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/" className="bg-bt-accent hover:bg-bt-accentHover text-white rounded px-8 py-3 font-medium">
            Back to safety
          </Link>
          <Link to="/docs" className="border border-bt-border rounded px-8 py-3 hover:border-bt-steel">
            Read the docs
          </Link>
        </div>
        <p className="mt-6 text-xs text-bt-muted">
          {BRAND.name} - {BRAND.tagline}
        </p>
      </div>
    </div>
  );
}
